import type { Connector } from '@avalara/types/index';
import conf from '../../conf';

// Filter out API connector details and return the object
export const getAPIConnectorDetails = (connectors: Array<Connector>): Connector => {
  const ApiConnector = connectors.filter((c) => c.id === 'a0n4000000ChMxlAAF')[0];
  // Need to copy because the items in state are read-only, so updating the
  // logo property on ApiConnector directly on the next line throws an error
  const ApiConnectorCopy = { ...ApiConnector };
  ApiConnectorCopy.logo = `${conf.ASSET_PATH}/assets/images/avalara_logo.png`;
  return ApiConnectorCopy;
};
